import defaultRequestConfig from 'Platforms/shopify/requestConfig';

const platformRoute = defaultRequestConfig?.platformRoute;

export const addPlatformRoute = <T extends string | undefined>(pathname: T): T =>
  platformRoute &&
  pathname?.startsWith('/') &&
  pathname !== platformRoute &&
  !pathname.startsWith(`${platformRoute}/`)
    ? (`${platformRoute}${pathname}` as T)
    : pathname;
